export default __webpack_public_path__ + "static/img/paper-bg.4b3f24c.jpg";